import { render, staticRenderFns } from "./SyaratKetentuan.vue?vue&type=template&id=4f9585b7&scoped=true"
import script from "./SyaratKetentuan.vue?vue&type=script&lang=js"
export * from "./SyaratKetentuan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9585b7",
  null
  
)

export default component.exports